export enum ArchivesViewMode {
  Searching,
  Empty,
  NoResults,
  Data,
}
